module.exports = __webpack_public_path__ + "static/img/VNM.a01343d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/countryFlag/VNM.svg
// module id = Kt1g
// module chunks = 66